import ForgotPasswordConfirmation from './ForgotPasswordConfirmation';

export default ForgotPasswordConfirmation;
